/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Practice_Score_ExcellentInputs */

const en_interview_practice_score_excellent = /** @type {(inputs: Interview_Practice_Score_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excellent!`)
};

const de_interview_practice_score_excellent = /** @type {(inputs: Interview_Practice_Score_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgezeichnet!`)
};

const fr_interview_practice_score_excellent = /** @type {(inputs: Interview_Practice_Score_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excellent !`)
};

const es_interview_practice_score_excellent = /** @type {(inputs: Interview_Practice_Score_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Excelente!`)
};

const it_interview_practice_score_excellent = /** @type {(inputs: Interview_Practice_Score_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eccellente!`)
};

const nl_interview_practice_score_excellent = /** @type {(inputs: Interview_Practice_Score_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitstekend!`)
};

const pl_interview_practice_score_excellent = /** @type {(inputs: Interview_Practice_Score_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doskonale!`)
};

const fi_interview_practice_score_excellent = /** @type {(inputs: Interview_Practice_Score_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erinomainen!`)
};

const da_interview_practice_score_excellent = /** @type {(inputs: Interview_Practice_Score_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fremragende!`)
};

const sv_interview_practice_score_excellent = /** @type {(inputs: Interview_Practice_Score_ExcellentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utmärkt!`)
};

/**
* | output |
* | --- |
* | "Excellent!" |
*
* @param {Interview_Practice_Score_ExcellentInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_score_excellent = /** @type {((inputs?: Interview_Practice_Score_ExcellentInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_Score_ExcellentInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_score_excellent(inputs)
	if (locale === "fr") return fr_interview_practice_score_excellent(inputs)
	if (locale === "es") return es_interview_practice_score_excellent(inputs)
	if (locale === "it") return it_interview_practice_score_excellent(inputs)
	if (locale === "nl") return nl_interview_practice_score_excellent(inputs)
	if (locale === "pl") return pl_interview_practice_score_excellent(inputs)
	if (locale === "fi") return fi_interview_practice_score_excellent(inputs)
	if (locale === "da") return da_interview_practice_score_excellent(inputs)
	if (locale === "sv") return sv_interview_practice_score_excellent(inputs)
	return en_interview_practice_score_excellent(inputs)
});